import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'

import Form from '../elements/Form'
import StaticInput from '../elements/forms/StaticInput'
import DateInput from '../elements/forms/DateInput'
import Dismissible from '../elements/Dismissible'
import LocationStickers from '../elements/LocationStickers'
import AppUtils from '../../utils/AppUtils'

const ERROR = {
  EMPTY_DATE: 'Veuillez choisir une date.'
}

class ControlGroupExecuteForm extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      input: this.getInitialInput(props),
      formError: null
    }

    // Bind events
    this.onSubmit = this.onSubmit.bind(this)
    this.onChangeInputDate = this.onChangeInputDate.bind(this)

    // Register submit event
    if (_.isFunction(this.props.registerSubmit)) {
      this.props.registerSubmit(this.onSubmit)
    }
  }

  getInitialInput(props = this.props) {
    return {
      date: null
    }
  }

  setInput(input = {}) {
    this.setState((prevState, props) => ({
      input: _.extend(
        {},
        prevState.input,
        input
      )
    }))
  }

  componentDidUpdate(prevProps, prevState) {
    // When async fetch finished
    if (prevProps.isLoading && !this.props.isLoading) {
      this.setState({
        input: this.getInitialInput()
      })
    }
  }

  onSubmit() {
    // Check that fields have been filled
    let formError = null
    if (_.isNull(this.state.input.date)) {
      formError = ERROR.EMPTY_DATE
    }
    this.setState({
      formError
    })
    if (!_.isNull(formError)) {
      return;
    }

    // Build and submit correctly formatted input
    this.props.onSubmit(this.state.input)
  }

  onChangeInputDate(date) {
    this.setInput({ date })
  }

  render() {
    return (
      <React.Fragment>
        {
          this.props.error
            ? <Dismissible
                header={AppUtils.errorToTitle(this.props.error)}
                content={AppUtils.errorToText(this.props.error)}
                color='red'
                onDismiss={this.props.onClearError}
              />
            : null
        }
        {
          !_.isNull(this.state.formError)
            ? <Dismissible
                content={this.state.formError}
                color='red'
              />
            : null
        }
        <Form
          onSubmit={this.onSubmit}
          loading={this.props.isLoading || this.props.isSaving}
        >
          <StaticInput
            label='Contrôle'
            content={this.props.group && this.props.group.control.name}
          />
          <StaticInput
            label='Groupe'
            content={this.props.group && this.props.group.name}
          />
          {
            this.props.group && _.isArray(this.props.group.locations)
              ? _.map(
                  this.props.group.locations,
                  (location, idx) => (
                    <StaticInput
                      label={ idx === 0 ? 'Emplacements' : '' }
                      smallPadding={ idx > 0 }
                      content={
                        <LocationStickers
                          stickers={location.stickers}
                        />
                      }
                    />
                  )
                )
              : null
          }
          <DateInput
            label='Effectué le'
            value={this.state.input.date}
            onChange={this.onChangeInputDate}
            allowBlurEmpty={false}
          />
        </Form>
      </React.Fragment>
    )
  }
}

ControlGroupExecuteForm.propTypes = {
  group: PropTypes.shape({
    name: PropTypes.string.isRequired,
    control: PropTypes.shape({
      name: PropTypes.string.isRequired
    }).isRequired,
    locations: PropTypes.array.isRequired
  }),
  onSubmit: PropTypes.func.isRequired,
  onClearError: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  registerSubmit: PropTypes.func,
  error: PropTypes.object
}

export default ControlGroupExecuteForm



// WEBPACK FOOTER //
// ./src/components/forms/ControlGroupExecuteForm.js